module.exports = __webpack_public_path__ + "img/assets/logo-milanowski--symbol-part.96be18f684e38711d5517c7ea437b920.svg";